import { render, staticRenderFns } from "./Calculator.vue?vue&type=template&id=52059d19&scoped=true"
import script from "./Calculator.vue?vue&type=script&lang=ts"
export * from "./Calculator.vue?vue&type=script&lang=ts"
import style0 from "./Calculator.vue?vue&type=style&index=0&id=52059d19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52059d19",
  null
  
)

export default component.exports